import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-daa8a10c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "enter-postcode"
}
const _hoisted_2 = { class: "enter-postcode__title h4" }
const _hoisted_3 = { class: "enter-postcode__subtitle" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-arrow-right" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputField = _resolveComponent("InputField")!
  const _component_AppButton = _resolveComponent("AppButton")!

  return (_ctx.pageContent)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.pageContent.title), 1),
        _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.pageContent.subtitle), 1),
        _createVNode(_component_InputField, {
          modelValue: _ctx.postcode,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.postcode) = $event)),
          label: "Postcode",
          name: "postcode",
          "full-width": "",
          change: _ctx.isValidPostcodeProvided
        }, null, 8, ["modelValue", "change"]),
        _createVNode(_component_AppButton, {
          class: "enter-postcode__next-button",
          disabled: !_ctx.isValidPostcodeProvided,
          "full-width": "",
          onClick: _ctx.submit
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", null, _toDisplayString(_ctx.pageContent.nextButtonCopy), 1),
            _hoisted_4
          ], undefined, true),
          _: 1
        }, 8, ["disabled", "onClick"])
      ]))
    : _createCommentVNode("", true)
}